import {
  SequenceMenu,
  SequenceMenuDivider,
  IconCheckmark
} from '@sequencehq/core-components'
import { useSetAtom } from 'jotai'
import {
  deleteDiscountAtom,
  deletePriceInPhaseAtom
} from '../../atoms/reviewPricing.atoms'
import { usePriceArrCalculation } from '../../utils/usePriceArrCalculation'
import { taskDrawerConfigAtom } from '../../../../../atoms'

export const PriceKebabMenu = (props: {
  phaseId: string
  priceId: string
  discountId?: string
  'data-testid'?: string
}) => {
  const deletePriceInPhase = useSetAtom(deletePriceInPhaseAtom)
  const setDrawer = useSetAtom(taskDrawerConfigAtom)
  const deleteDiscount = useSetAtom(deleteDiscountAtom)

  const { value: priceArrCalculation, update: updatePriceArrCalculation } =
    usePriceArrCalculation({
      phaseId: props.phaseId,
      priceId: props.priceId
    })

  return (
    <SequenceMenu
      variant="ghost"
      buttonSize="small"
      alignment="bottom-right"
      data-testid={props['data-testid']}
      items={[
        ({ setIsOpen }) => (
          <SequenceMenu.Item
            key="editPrice"
            uuid="edit-price"
            label="Edit price"
            data-testid={`${props['data-testid']}.edit`}
            onClick={() => {
              setDrawer({
                type: 'PRICE',
                phaseId: props.phaseId,
                priceId: props.priceId
              })
              setIsOpen?.(false)
            }}
          />
        ),
        ({ setIsOpen }) => {
          return (
            props.discountId && (
              <SequenceMenu.Item
                key="editDiscount"
                uuid="edit-discount"
                label="Edit discount"
                data-testid={
                  props['data-testid'] && `${props['data-testid']}.editDiscount`
                }
                onClick={() => {
                  setDrawer({
                    type: 'DISCOUNT',
                    phaseId: props.phaseId,
                    discountId: props.discountId
                  })
                  setIsOpen?.(false)
                }}
              />
            )
          )
        },
        ({ setIsOpen }) => (
          <SequenceMenu.Item
            key="arrCalculation"
            uuid="arr-calculation"
            label="ARR calculation"
            data-testid={
              props['data-testid'] && `${props['data-testid']}.arrCalculation`
            }
            subItems={[
              {
                label: 'Include (default)',
                iconRight:
                  priceArrCalculation !== 'EXCLUDE' ? (
                    <IconCheckmark />
                  ) : undefined,
                onClick: () => {
                  updatePriceArrCalculation('INCLUDE')
                  setIsOpen?.(false)
                }
              },
              {
                label: 'Exclude',
                iconRight:
                  priceArrCalculation === 'EXCLUDE' ? (
                    <IconCheckmark />
                  ) : undefined,
                onClick: () => {
                  updatePriceArrCalculation('EXCLUDE')
                  setIsOpen?.(false)
                }
              }
            ]}
          />
        ),
        <SequenceMenuDivider key="divider" />,
        ({ setIsOpen }) => {
          return (
            props.discountId && (
              <SequenceMenu.Item
                key="removeDiscount"
                uuid="remove-discount"
                label="Remove discount"
                data-testid={
                  props['data-testid'] &&
                  `${props['data-testid']}.deleteDiscount`
                }
                onClick={() => {
                  if (!props.discountId) return

                  deleteDiscount({
                    phaseId: props.phaseId,
                    discountId: props.discountId,
                    priceId: props.priceId
                  })

                  setIsOpen?.(false)
                }}
                destructive
              />
            )
          )
        },
        ({ setIsOpen }) => (
          <SequenceMenu.Item
            key="removePrice"
            uuid="remove-price"
            label="Remove price"
            data-testid={
              props['data-testid'] && `${props['data-testid']}.delete`
            }
            onClick={() => {
              deletePriceInPhase({
                phaseId: props.phaseId,
                priceId: props.priceId
              })
              setIsOpen?.(false)
            }}
            destructive
          />
        )
      ]}
    />
  )
}
